import { UserState } from "@user/models/UserByEmailResponse";

import CheckCircleBlue from "@icons/checkBlueCircle.svg?react";
import CheckCircle from "@icons/checkCircle.svg?react";
import CloseCircle from "@icons/closeCircle.svg?react";

interface Props {
  state: string;
}

export const UserStatusIcon = ({ state }: Props) => {
  const renderIcon = () => {
    switch (state) {
      case UserState.Active:
        return (
          <div data-testid="active-user-status">
            <CheckCircle />
          </div>
        );

      case UserState.Invited:
        return (
          <div data-testid="invited-user-status">
            <CheckCircleBlue />
          </div>
        );

      case UserState.InvitationExpired:
        return (
          <div data-testid="invitation-expired-user-status">
            <CloseCircle />
          </div>
        );

      case UserState.Inactive:
        return (
          <div data-testid="inactive-user-status">
            <CloseCircle />
          </div>
        );

      default:
        return null;
    }
  };

  return <>{renderIcon()}</>;
};
